var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgEmptyAnswers = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 140,
  height: 140,
  viewBox: "0 0 140 140",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h140v140H0z"
}), /*#__PURE__*/React.createElement("g", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  stroke: "#00B177",
  strokeWidth: 3
}, /*#__PURE__*/React.createElement("path", {
  d: "M104.103 55.836v50.92c0 6.465-5.219 11.706-11.655 11.706H28.345c-3.218 0-5.828-2.62-5.828-5.853v-81.94c0-3.233 2.61-5.853 5.828-5.853H73.8M104.103 10.77v30.434M87.786 24.816h32.634M59.813 57.006h27.972"
}), /*#__PURE__*/React.createElement("path", {
  d: "m48.159 54.08-8.966 7.024-2.69-2.105M59.813 87.441h27.972M48.159 84.515l-8.966 7.023-2.69-2.104"
})))));
export default SvgEmptyAnswers;